import React, { act, useMemo } from "react";
import { useSearchspringFilters } from "@app/hooks/use-searchspring-filters";
import { Icon } from "./icon";
import clsx from "clsx";
import { useSearchspringSearchContext } from "@app/providers/searchspring";

type Props = {
  className?: string;
};

export function ResultActiveFilter({ className }: Props) {
  const { response } = useSearchspringSearchContext();
  const { activeFilters, handleRemoveFilter, handleClearFilters } = useSearchspringFilters();

  const fetchedFilters = useMemo(() => {
    return response?.facets ?? [];
  }, [response]);

  const parsedFilters = Array.from(activeFilters).map((filter) => {
    const [field, label] = filter.replace("<>", " - ").split(":");

    const fetchedFilter = fetchedFilters.find((current) => current.field === field);
    if (!fetchedFilter) return [label, filter];

    const activeValue = fetchedFilter.values.find((value) => {
      return value.active && value.label === label;
    });

    return [activeValue?.label ?? label, filter];
  });

  if (!activeFilters || !activeFilters.size) return null;

  return (
    <div className={clsx("no-scrollbar flex min-h-min items-center gap-2 overflow-x-scroll", className)}>
      <button
        className="flex items-center gap-1 px-3 py-2 border rounded-lg font-label text-body-sm shrink-0 border-neutrals-black"
        onClick={handleClearFilters}
      >
        <Icon id="Cross" className="size-3 text-neutrals-black" />
        <span>Clear All</span>
      </button>
      {parsedFilters.map(([label, filter]) => {
        return (
          <button
            className="flex items-center gap-1 px-3 py-2 rounded-lg font-label text-body-sm shrink-0 bg-neutrals-grey-5"
            onClick={() => handleRemoveFilter(filter)}
          >
            <Icon id="Cross" className="size-3 text-neutrals-black" />
            <span>{label}</span>
          </button>
        );
      })}
      <div className="sticky right-0 min-h-16 min-w-60 bg-gradient-to-r from-white/0 to-white" />
    </div>
  );
}
